import Highway from '@dogstudio/highway';
import Grid from '../_modules/grid';
import Filters from '../_modules/filters';
import Menu from '../_modules/menu';

class ProjectGrid extends Highway.Renderer {
  onEnter() {
    Grid.init();
    Filters.init();
    Menu.init();
  }
  onEnterCompleted() {
    setTimeout(function(){
      document.querySelector('.grid__null').classList.remove('grid__null--start');
    }, 500)
  }
}

export default ProjectGrid;
